<template>
  <div class="home">
    <agency-left ref="agencyLeft" class="page-left" />
    <agency-middle class="page-middle" @download="downloadFn" />
    <home-right class="page-right" />
  </div>
</template>

<script>
import HomeRight from '@/views/Home/components/HomeRight'
import AgencyLeft from '@/views/Setting/components/AgencyLeft'
import AgencyMiddle from '@/views/Setting/components/AgencyMiddle'
import { fileDownload } from '@/utils/tool'
export default {
  name: 'AgencyList',
  components: { AgencyMiddle, AgencyLeft, HomeRight },
  methods: {
    downloadFn() {
      const temp = {
        data: {
          list: this.$refs.agencyLeft.agencyList
        }
      }
      fileDownload(JSON.stringify(temp), 'agency_data.json')
    }
  }
}
</script>

<style lang="less" scoped>
  .home{
    width: 100%;
    height: 1285px;
    color: #ffffff;
    padding: 0 30px 40px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .page-left, .page-middle, .page-right{
    height: 100%;
  }
  .page-left, .page-right{
    width: 455px;
  }
  .page-middle{
    flex: 1;
    margin: 0 11px;
  }
</style>
<style lang="less">
  body{
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
